// constants
import { showSuccessAlert } from "../../constants/alerts";
import { WithDrawActionTypes } from "./constants";

const INIT_STATE = {
  withdraws: [],
  pagination: null,
  loading: false,
  initialLoading: false,
  error: null,
};

interface WithDrawActionType {
  type:
    | WithDrawActionTypes.API_RESPONSE_SUCCESS
    | WithDrawActionTypes.API_RESPONSE_ERROR
    | WithDrawActionTypes.GET_DATA
    | WithDrawActionTypes.WITHDRAW_STATUS;

  payload: {
    actionType?: string;
    data?: any | {};
    error?: string;
    message?: string;
  };
}

const Withdraws = (state: any = INIT_STATE, action: WithDrawActionType): any => {
  switch (action.type) {
    case WithDrawActionTypes.API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case WithDrawActionTypes.GET_DATA: {
          return {
            ...state,
            withdraws: action.payload.data.withdraw_requests,
            pagination: action.payload.data.pagination,
            loading: false,
            initialLoading: false,
            error: null,
          };
        }

        case WithDrawActionTypes.WITHDRAW_STATUS: {
          showSuccessAlert(action.payload.data);
          return {
            ...state,
            loading: false,
            error: null,
          };
        }

        default:
          return { ...state };
      }

    case WithDrawActionTypes.API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case WithDrawActionTypes.GET_DATA: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
            initialLoading: false,
          };
        }
        case WithDrawActionTypes.WITHDRAW_STATUS: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
            initialLoading: false,
          };
        }

        default:
          return { ...state };
      }

    case WithDrawActionTypes.GET_DATA:
      return { ...state, loading: true, initialLoading: true };
    case WithDrawActionTypes.WITHDRAW_STATUS:
      return { ...state, loading: true, initialLoading: true };

    default:
      return { ...state };
  }
};

export default Withdraws;
